module.exports = __webpack_public_path__ + "static/media/smalltag.c952ab27.svg";